import FullSite from "./full-site";
import { CasinoTemplate } from "../../jamibet/desktop-pages/casino";

export default function Casino(props) {
	return <FullSite><CasinoTemplate {...props} /></FullSite>;
}
